import { PaginationArgs } from '@/@generated/codegen/API';
import {
  QUERY_PARAM_PAGINATION_AFTER_KEY,
  QUERY_PARAM_PAGINATION_BEFORE_KEY,
} from '@/hooks/usePaginationState';
import { useQueryParams } from '@/hooks/useQueryParams';

export const usePaginationQueryParam = (pageSize: number, prefix: string | null) => {
  const { before, after } = useQueryParams(
    [QUERY_PARAM_PAGINATION_BEFORE_KEY, QUERY_PARAM_PAGINATION_AFTER_KEY],
    prefix
  );
  const paginationArgs: PaginationArgs = {
    before: before,
    after: after,
  };

  if (paginationArgs.after) {
    paginationArgs.first = pageSize;
  } else if (paginationArgs.before) {
    paginationArgs.last = pageSize;
  } else {
    paginationArgs.first = pageSize;
  }

  return paginationArgs;
};
